/* ============================================================
   HIT Energy — native Shopify cart

   1) Injects a gold "Shop Now" button into the top-right header,
      alongside the native cart icon.
   2) Appends the Bourvic Studio signature to the footer, site-wide.

   ------------------------------------------------------------
   ARCHITECTURE NOTE (2026-08-31)

   This file used to derive the homepage buy buttons from external
   retailer links: it queried the DOM for those links and inserted an
   "Add to Cart" beside each one. The buy path therefore existed only
   as a side effect of an external link being present — remove the
   links and the homepage lost every buy button.

   That coupling is gone. The hero, mission and trust-block buy
   buttons are now REAL LINKS written directly into
   templates/index.json and depend on this script for nothing.

   Keep it that way: a store's buy path should never be a side
   effect of third-party markup. Restoration details live in the
   project runbook, not here.
   ============================================================ */
(function () {
  var PRODUCT_URL = "/products/hit-energy-shot";
  var BOURVIC_URL = "https://bourvicstudio.com";
  var BOURVIC_LOGO = "https://cdn.shopify.com/s/files/1/0968/6581/2553/files/bourvic-monogram-gold.webp?v=1787266700&width=60";

  /* ---- Top-right "Shop Now" button (sits next to the cart icon) ---- */
  function injectHeaderCta() {
    var actions = document.querySelector('header-actions');
    if (!actions || actions.querySelector('.hit-shop-now')) return;
    var a = document.createElement('a');
    a.className = 'button hit-shop-now hit-atc-btn hit-atc-btn--header';
    a.href = PRODUCT_URL;
    // "Now" is hidden under 750px: at 320px the full label collides with the
    // centred logo. See injectHeaderCtaStyles() below.
    a.innerHTML = 'Shop<span class="hit-shop-now__full"> Now</span>';
    a.setAttribute('style', 'padding:10px 20px;border-radius:12px;font-weight:700;text-decoration:none;white-space:nowrap;display:inline-flex;align-items:center;margin-right:12px;');
    actions.insertBefore(a, actions.firstChild);
  }

  /* ---- Header CTA responsive rules ----
     Scoped to .hit-shop-now on purpose. These live here rather than in
     hit-custom.css because broad selectors in that file have collided with
     third-party markup three times (see the runbook incident log). */
  function injectHeaderCtaStyles() {
    if (document.getElementById('hit-shop-now-css')) return;
    var s = document.createElement('style');
    s.id = 'hit-shop-now-css';
    s.textContent =
      '@media (max-width:749px){' +
      '.hit-shop-now__full{display:none;}' +
      '.hit-shop-now{padding:8px 14px !important;font-size:0.85rem !important;margin-right:8px !important;}' +
      '}';
    document.head.appendChild(s);
  }

  /* ---- Bourvic Studio signature (site-wide footer) ---- */
  function injectSignature() {
    if (document.querySelector('.bourvic-sig')) return;
    var host = document.querySelector('.footer') || document.querySelector('footer') || document.querySelector('[class*="footer"]') || document.body;
    var d = document.createElement('div');
    d.className = 'bourvic-sig';
    d.innerHTML = "<a href='" + BOURVIC_URL + "' target='_blank' rel='noopener'><img class='bourvic-sig__logo' src='" + BOURVIC_LOGO + "' alt='Bourvic Studio' width='30' height='21' loading='lazy'><span class='bourvic-sig__name'>Bourvic Studio</span><span class='bourvic-sig__sep'>&middot;</span><span class='bourvic-sig__year'>MMXXVI</span></a>";
    host.appendChild(d);
  }

  /* ============================================================
     21+ age verification gate.

     BUILT BUT DISABLED. The card processor asked for a 21+ gate;
     HIT has argued back that paraxanthine is caffeine-equivalent and
     should not need one. The processor accepted the 18+ position on 2026-09-03 and no
     longer requires a gate, so this stays off. AGE_GATE_MIN_AGE is set
     to 18 to match every other age statement on the site.

     Styles are inline on purpose: a compliance gate must not depend
     on an external stylesheet loading.
     ============================================================ */
  var AGE_GATE_ENABLED = false;
  var AGE_GATE_MIN_AGE = 18;
  var AGE_GATE_KEY = 'hit-age-ok';

  function ageGate() {
    if (!AGE_GATE_ENABLED) return;
    try { if (localStorage.getItem(AGE_GATE_KEY) === '1') return; } catch (e) {}
    if (document.getElementById('hit-age-gate')) return;

    var ov = document.createElement('div');
    ov.id = 'hit-age-gate';
    ov.setAttribute('role', 'dialog');
    ov.setAttribute('aria-modal', 'true');
    ov.setAttribute('aria-label', 'Age verification');
    ov.setAttribute('style', 'position:fixed;inset:0;z-index:99999;background:rgba(5,5,5,0.97);display:flex;align-items:center;justify-content:center;padding:24px;');

    var card = document.createElement('div');
    card.setAttribute('style', 'max-width:460px;width:100%;text-align:center;border:1px solid rgba(255,199,0,0.35);border-radius:18px;padding:36px 30px;background:#0a0a0a;color:#fff;font-family:Inter,system-ui,sans-serif;');
    card.innerHTML =
      "<h2 style='margin:0 0 10px;font-family:Archivo,sans-serif;font-size:1.5rem;'>Are you " + AGE_GATE_MIN_AGE + " or older?</h2>" +
      "<p style='margin:0 0 22px;opacity:.8;font-size:.92rem;line-height:1.5;'>You must be " + AGE_GATE_MIN_AGE +
      " years or older to purchase from this website. This product is not intended for children, or pregnant or lactating women.</p>";

    var yes = document.createElement('button');
    yes.type = 'button';
    yes.textContent = "Yes, I am " + AGE_GATE_MIN_AGE + " or older";
    yes.setAttribute('style', 'display:block;width:100%;margin:0 0 10px;padding:14px 22px;border:none;border-radius:14px;background:#ffc700;color:#0a0a0a;font-weight:700;font-size:1rem;cursor:pointer;font-family:inherit;');

    var no = document.createElement('button');
    no.type = 'button';
    no.textContent = 'No';
    no.setAttribute('style', 'display:block;width:100%;padding:14px 22px;border:1px solid rgba(255,255,255,0.28);border-radius:14px;background:transparent;color:#fff;font-weight:700;font-size:1rem;cursor:pointer;font-family:inherit;');

    yes.addEventListener('click', function () {
      try { localStorage.setItem(AGE_GATE_KEY, '1'); } catch (e) {}
      ov.remove();
      document.documentElement.style.overflow = '';
    });
    no.addEventListener('click', function () {
      card.innerHTML = "<h2 style='margin:0 0 10px;font-family:Archivo,sans-serif;font-size:1.4rem;'>Sorry</h2>" +
        "<p style='margin:0;opacity:.8;font-size:.92rem;line-height:1.5;'>You must be " + AGE_GATE_MIN_AGE +
        " years or older to purchase from this website.</p>";
    });

    card.appendChild(yes);
    card.appendChild(no);
    ov.appendChild(card);
    document.documentElement.style.overflow = 'hidden';
    document.body.appendChild(ov);
    yes.focus();
  }

  function ready(fn){ if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  ready(ageGate);
  ready(injectHeaderCtaStyles);
  ready(injectHeaderCta);
  ready(injectSignature);

  /* The header re-renders on cart updates and section reloads — re-inject.
     Debounced: an undebounced observer re-runs on every DOM mutation and
     reintroduces the mobile jank fixed in 2026-08. */
  var hg = document.getElementById('header-group');
  if (hg && window.MutationObserver) {
    var pending = null;
    new MutationObserver(function () {
      if (pending) return;
      pending = requestAnimationFrame(function () { pending = null; injectHeaderCta(); });
    }).observe(hg, { childList: true, subtree: true });
  }
  document.addEventListener('cart:update', injectHeaderCta);
})();


/* ------------------------------------------------------------------------------------------
 * Free Samples giveaway -> Klaviyo hand-off (added 2026-09-11)
 * Runs only where form.hit-gwf exists (/pages/giveaway). Sends the entry to Klaviyo, then
 * submits the form to web3forms exactly as before, so Dustin's notification email is unchanged.
 * - every entrant: Klaviyo profile + "Submitted Giveaway Entry" event
 * - only entrants who tick "Marketing Opt In": subscribed to the "Email" list (QQrBsD)
 * - city + state ARE sent as Klaviyo location (Official Rule 8 reworded 2026-09-11);
 *   street address, apt and ZIP are NOT sent
 * - fail-safe: web3forms submission always happens, at most 3 s after the click
 * ---------------------------------------------------------------------------------------- */
(function () {
  var LIST_ID = 'QQrBsD', CO = 'XnL6R3', REV = '2024-10-15';
  function init() {
    var f = document.querySelector('form.hit-gwf');
    if (!f || f.dataset.klv) return;
    f.dataset.klv = '1';
    function v(n) { var e = f.elements[n]; if (!e) return ''; if (e.type === 'checkbox') return e.checked; return (e.value || '').trim(); }
    function post(path, body) {
      return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + CO, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'revision': REV },
        body: JSON.stringify(body)
      });
    }
    f.addEventListener('submit', function (ev) {
      ev.preventDefault();
      if (f.dataset.sending) return;
      f.dataset.sending = '1';
      var btn = f.querySelector('button[type="submit"]');
      if (btn) { btn.disabled = true; btn.textContent = 'Sending...'; }
      var done = false;
      function finish() { if (done) return; done = true; HTMLFormElement.prototype.submit.call(f); }
      try {
        if (v('botcheck') === true) { finish(); return; }
        var email = v('email'), optin = v('Marketing Opt In') === true, fn = v('First Name'), ln = v('Last Name');
        var loc = { city: v('City'), region: v('State'), country: 'United States' };
        var props = {
          'Giveaway Entrant': true, 'Giveaway Entry Date': new Date().toISOString(), 'Giveaway Marketing Opt In': optin,
          'Age Range': v('Age Range'), 'Occupation': v('Occupation'), 'Current Energy Source': v('Current Energy Source'),
          'Tried HIT': v('Tried HIT'), 'Social Handle': v('Social Handle'), 'Requested Retailer': v('Requested Retailer')
        };
        var jobs = [
          post('profiles', { data: { type: 'profile', attributes: { email: email, first_name: fn, last_name: ln, location: loc, properties: props } } }),
          post('events', { data: { type: 'event', attributes: {
            properties: { 'Occupation': props['Occupation'], 'Current Energy Source': props['Current Energy Source'], 'Tried HIT': props['Tried HIT'], 'Marketing Opt In': optin },
            metric: { data: { type: 'metric', attributes: { name: 'Submitted Giveaway Entry' } } },
            profile: { data: { type: 'profile', attributes: { email: email } } } } } })
        ];
        if (optin) {
          jobs.push(post('subscriptions', { data: { type: 'subscription',
            attributes: { custom_source: 'Free Samples giveaway form', profile: { data: { type: 'profile', attributes: { email: email } } } },
            relationships: { list: { data: { type: 'list', id: LIST_ID } } } } }));
        }
        try { if (window.klaviyo && window.klaviyo.identify) window.klaviyo.identify({ email: email, first_name: fn, last_name: ln }); } catch (e) {}
        Promise.allSettled(jobs).then(finish, finish);
        setTimeout(finish, 3000);
      } catch (e) { finish(); }
    }, true);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
